import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
const Hero = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollTop / docHeight;
      setScrollProgress(Math.min(progress, 1));
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToProjects = () => {
    const element = document.querySelector("#projects");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return <section id="hero" className="min-h-screen flex items-center justify-center relative overflow-hidden bg-background">
      {/* Fixed gradient bar that expands based on scroll */}
      <div className="fixed top-0 left-0 h-2 gradient-rainbow z-50 transition-all duration-300 ease-out rounded-r-full" style={{
      width: `${scrollProgress * 100}%`
    }}></div>

      <div className="container mx-auto px-8 py-20">
        <div className="max-w-6xl mx-auto">
          <div className="animate-fade-in">
            <h1 className="text-huge font-black mb-8 leading-none">
              Découvrez
              <br />
              <span className="bg-accent text-accent-foreground px-4 py-1 pb-4 inline-flex items-center">mon portfolio</span>
              <br />
              
            </h1>
            
            <div className="grid lg:grid-cols-2 gap-12 items-center mt-16">
              <div className="space-y-6">
                <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">Je suis Savinien Gicquel, étudiant passionné en bachelor 3 en création digital spécialité développement web. Je crée des expériences digitales modernes et innovantes.</p>

                <div className="flex flex-col sm:flex-row gap-4">
                  <Button onClick={scrollToProjects} size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8 py-6 rounded-nobilito font-semibold">
                    Découvrir mes projets
                  </Button>
                </div>
              </div>

              {/* Illustration area - improved proportions */}
              <div className="relative">
                <div className="grid grid-cols-2 gap-6">
                  <div className="card-yellow rounded-nobilito p-6 hover-lift h-40 flex flex-col justify-between">
                    <div className="text-3xl">🎨</div>
                    <div>
                      <h3 className="font-bold text-lg mb-1">Design</h3>
                      <p className="text-sm opacity-90 leading-tight">Interface moderne et intuitive</p>
                    </div>
                  </div>
                  <div className="card-blue rounded-nobilito p-6 hover-lift mt-6 h-40 flex flex-col justify-between">
                    <div className="text-3xl">⚡</div>
                    <div>
                      <h3 className="font-bold text-lg mb-1">Performance</h3>
                      <p className="text-sm opacity-90 leading-tight">Applications rapides et optimisées</p>
                    </div>
                  </div>
                  <div className="card-green rounded-nobilito p-6 hover-lift -mt-3 h-40 flex flex-col justify-between">
                    <div className="text-3xl">🚀</div>
                    <div>
                      <h3 className="font-bold text-lg mb-1">Innovation</h3>
                      <p className="text-sm opacity-90 leading-tight">Technologies de pointe</p>
                    </div>
                  </div>
                  <div className="card-pink rounded-nobilito p-6 hover-lift mt-3 h-40 flex flex-col justify-between">
                    <div className="text-3xl">💡</div>
                    <div>
                      <h3 className="font-bold text-lg mb-1">Créativité</h3>
                      <p className="text-sm opacity-90 leading-tight">Solutions sur mesure</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;